<ui-map-with-sidebar
    [mapItems]="(mapItems$ | async) ?? fallbackMapItems"
    [popupContentComponentType]="popupContentComponentType"
    [listCustomContentComponentType]="listCustomContentComponentType"
    (reloadMapData)="reloadMapData()"
>
    <ui-school-map-filters filters/>
    <ui-school-map-item-details
        map-item-details
        [mapItem]="(detailViewItem$ | async) ?? undefined"
    />
</ui-map-with-sidebar>
